module.exports = __webpack_public_path__ + "static/media/Dr.R.c382fc32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/Dr.R.svg
// module id = 220
// module chunks = 0